import clsx from 'clsx'
import {isEmpty} from 'lodash'
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG, convertCurrency} from '../../../helpers'
import {ROUNDED_LOGO_CARRIERS} from '../../../constants'

type Props = {
  handleGetRate?: any
  alignItem?: any
  isInline?: boolean
  loadingRate?: boolean
  service: any
  isCheapest?: boolean
  cost?: any
  isHiddenSerVice?: boolean
  isHiddenCost?: boolean
}

const CarrierBadge: React.FC<Props> = ({
  handleGetRate,
  loadingRate,
  service,
  isCheapest = false,
  isHiddenCost = false,
  isHiddenSerVice = false,
  cost,
  alignItem = 'justify-content-center',
  isInline = false,
}) => {
  const intl = useIntl()
  return (
    <div className={`d-flex align-items-center align-middle ${alignItem}`}>
      <div className='d-flex flex-column'>
        {!isHiddenSerVice ? (
          <div
            className={clsx('d-flex', {
              'align-items-center gap-2': isInline,
              'flex-column': !isInline,
            })}
          >
            {!isEmpty(service) && (
              <div
                className={clsx(
                  'symbol symbol-circle symbol-25px overflow-hidden d-flex justify-content-center',
                  {
                    'flex-shrink-0': isInline,
                  }
                )}
              >
                <div className='symbol-label'>
                  <img
                    src={service.visuals?.logo}
                    alt='logo'
                    className={clsx('w-100', {
                      'rounded-circle': ROUNDED_LOGO_CARRIERS.includes(
                        `${service.carrier}_${service.service}`
                      ),
                    })}
                  />
                </div>
              </div>
            )}

            <div
              className={clsx('d-flex', {
                'align-items-center text-start': isInline,
                'justify-content-center text-center': !isInline,
              })}
            >
              <span
                className={clsx({
                  'mb-0': isInline,
                  'mb-1': !isInline,
                })}
                style={{fontSize: '12px'}}
              >
                {service.visuals?.display_name}
              </span>
            </div>
          </div>
        ) : (
          <span></span>
        )}

        {!isHiddenCost && (
          <div
            className={clsx('d-flex', {
              'justify-content-start': isInline,
              'justify-content-center': !isInline,
            })}
          >
            {isEmpty(cost) && handleGetRate ? (
              <div
                className={'btn-icon text-hover-primary cursor-pointer mb-2'}
                onClick={handleGetRate}
              >
                <KTSVG
                  path='/media/gori/orders/refresh.svg'
                  className={clsx('svg-icon svg-icon-4')}
                  svgClassName={clsx({spin_reverse: loadingRate})}
                />
              </div>
            ) : cost && cost > 0 ? (
              <span className='text-gray-800'>{convertCurrency(cost)}</span>
            ) : (
              <span></span>
            )}
          </div>
        )}
        {isCheapest && (
          <div className='d-flex justify-content-center'>
            <span className='text-truncate badge badge-pill badge-light'>
              {intl.formatMessage({id: 'CHEAPEST'})}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export {CarrierBadge}
